import { ProductAccessoriesActionState } from "@/app/blu/shop/actions";

export const ProductAccessoriesNotFound = ({
  response,
}: ProductAccessoriesNotFoundProps) => {
  return (
    <section data-testid="product-accessories-not-found">
      No results found for "{response.search}".
    </section>
  );
};

export type ProductAccessoriesNotFoundProps = {
  response: ProductAccessoriesActionState;
};
